import { Badge } from "oneclick-component/src/components/Badge";
import { ReactElement } from "react";
import cn from "classnames";
import { Trans } from "react-i18next";

interface Props {
  className?: string;
}

const PTUserSuspendedBadge = (props: Props): ReactElement => {
  const { className } = props;
  // TODO(peter)#556 #568: load user 418 status and change this badger color
  return (
    <Badge
      className={cn("text-black/24", "border", "border-black/24", className)}
    >
      <Trans i18nKey="partTime.badge.suspended" />
    </Badge>
  );
};

export default PTUserSuspendedBadge;
